import HomePage from './HomePage'

export default HomePage



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomePage/index.js